import { z } from 'zod';

export const preferenceSchema = z.array(
    z.object({
        id: z.string().readonly(),
        name: z.string().readonly(),
        type: z
            .enum(['Newsletter', 'DataUses', 'Consent', 'Interests'])
            .readonly(),
        description: z.string().optional().readonly(),
        isSelected: z.boolean().readonly(),
    })
);

export const getPreferencesSchema = z.object({
    antiForgeryToken: z.string(),
    subscriptions: preferenceSchema,
    data: z.object({
        disclaimerText: z.string().readonly(),
        saveLabel: z.string().readonly(),
        partialUpdateDetails: z
            .object({
                id: z.string().readonly(),
                token: z.string().readonly(),
            })
            .optional(),
    }),
    contactDetails: z
        .object({
            email: z.string().email(),
            mobile: z.string().readonly(),
        })
        .optional(),
});
